import { Box, IconButton } from '@mui/material';
import { FirstPage, LastPage, KeyboardArrowLeft, KeyboardArrowRight } from '@mui/icons-material';

interface TablePaginationActionsProps {
    count: number;
    page: number;
    rowsPerPage: number;
    onPageChange: (event: React.MouseEvent<HTMLButtonElement>, newPage: number) => void;
}

/**
 * Renders the pagination navigation buttons.
 *
 * @param {TablePaginationActionsProps} props
 * @returns {JSX.Element}
 */
const TablePaginationActions = ({ count, page, rowsPerPage, onPageChange }: TablePaginationActionsProps) => {
    const handleFirstPageClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        onPageChange(event, 0);
    };

    const handlePreviousPageClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        onPageChange(event, page - 1);
    };

    const handleNextPageClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        onPageChange(event, page + 1);
    };

    const handleLastPageClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
        <Box sx={{ flexShrink: 0, ml: 2.5 }}>
            <IconButton onClick={handleFirstPageClick} disabled={page === 0} aria-label="first page" sx={{ p: 0.5, mx: -0.25 }}>
                <FirstPage />
            </IconButton>
            <IconButton onClick={handlePreviousPageClick} disabled={page === 0} aria-label="previous page" sx={{ p: 0.5, mx: -0.25 }}>
                <KeyboardArrowLeft />
            </IconButton>
            <IconButton
                onClick={handleNextPageClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
                sx={{ p: 0.5, mx: -0.25 }}
            >
                <KeyboardArrowRight />
            </IconButton>
            <IconButton
                onClick={handleLastPageClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
                sx={{ p: 0.5, mx: -0.25 }}
            >
                <LastPage />
            </IconButton>
        </Box>
    );
};

export default TablePaginationActions;
